import _suggestAdd from "@zenlayer/zen-design-icons/assets/suggest/Add.svg";
import _directionUpLine from "@zenlayer/zen-design-icons/assets/direction/UpLine.svg";
import _suggestMinus from "@zenlayer/zen-design-icons/assets/suggest/Minus.svg";
import _directionDownLine from "@zenlayer/zen-design-icons/assets/direction/DownLine.svg";
import { useControllableValue, useCreation, useDebounce, useFocusWithin } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { isNone, isNumber } from '../_util/defineType';
import insertRipple from '../_util/insertRipple';
import { calc, pickDomAttrs } from '../_util/utils';
import Explain from '../explain';
import Icon from '../icon';
import Tooltip from '../tooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//壳子
const Wrap = props => {
  const {
    size = 'm',
    type,
    direction = 'vertical',
    disabled,
    focusWithin,
    tooltip,
    error,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-inputNumber");
  const attrs = pickDomAttrs(restProps);
  const _focusWithin = useDebounce(focusWithin, {
    wait: 100
  });
  return /*#__PURE__*/_jsx(Explain, {
    helperText: error === true ? undefined : error,
    children: /*#__PURE__*/_jsx(Tooltip, {
      open: _focusWithin && !isNone(tooltip === null || tooltip === void 0 ? void 0 : tooltip.title) ? true : false,
      title: tooltip === null || tooltip === void 0 ? void 0 : tooltip.title,
      placement: tooltip === null || tooltip === void 0 ? void 0 : tooltip.placement,
      align: {
        offset: [0, 4]
      },
      children: /*#__PURE__*/_jsx("div", {
        ...attrs.data,
        className: classNames(baseClassName, className, type, {
          ["".concat(baseClassName, "-").concat(direction)]: !!direction,
          ["".concat(baseClassName, "-").concat(size)]: !!size,
          ["".concat(baseClassName, "-disabled")]: !!disabled
        }),
        style: style,
        children: props.children
      })
    })
  });
};

//input
const ContentDom = _ref2 => {
  let {
    type,
    error,
    disabled,
    incDisabled,
    decDisabled,
    step,
    value,
    onChange,
    onBlur: onPropsBlur,
    suffix,
    max,
    min,
    precision,
    inputWidth,
    _ref
  } = _ref2;
  const [valueStr, setValueStr] = useState(value === undefined ? '' : value.toString());
  const onBlur = e => {
    if (valueStr === undefined || valueStr === '') {
      if (isNumber(min)) {
        onChange(min);
        setValueStr(min.toString());
        onPropsBlur === null || onPropsBlur === void 0 || onPropsBlur(min, e);
      } else {
        onPropsBlur === null || onPropsBlur === void 0 || onPropsBlur(undefined, e);
      }
    } else {
      let effectiveValue = Number(valueStr);
      if (isNumber(max) && effectiveValue > max) {
        effectiveValue = max;
        onChange(effectiveValue);
      } else if (isNumber(min) && effectiveValue < min) {
        effectiveValue = min;
        onChange(effectiveValue);
      }
      setValueStr(effectiveValue.toString());
      onPropsBlur === null || onPropsBlur === void 0 || onPropsBlur(effectiveValue, e);
    }
  };
  useEffect(() => {
    if (value === undefined || isNumber(value)) {
      setValueStr(value === undefined ? '' : value.toString());
    }
  }, [value]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('content', type, {
      disabled,
      error
    }),
    style: {
      width: inputWidth
    },
    ref: ref => {
      insertRipple({
        ref
      });
    },
    children: [/*#__PURE__*/_jsx("input", {
      ref: _ref,
      type: "text",
      disabled: disabled,
      value: valueStr,
      onChange: e => {
        let val = e.target.value.trim();
        if (val === '') {
          setValueStr(val);
          onChange(undefined);
        } else if (isNumber(Number(val), true) && Number(val) <= Math.max(Number('9'.repeat(max.toString().length)), 999999999)) {
          if (val.includes('.')) {
            const [integer, decimal] = val.split('.');
            val = precision ? "".concat(integer, ".").concat(decimal.slice(0, precision)) : integer;
          }
          setValueStr(val);
          onChange(Number(val));
        }
      },
      onBlur: onBlur,
      onKeyDown: e => {
        if (e.key === 'ArrowUp' && !incDisabled) {
          const val = Math.min(calc.add(Number(value || 0), step), max);
          setValueStr(val.toString());
          onChange(val);
        } else if (e.key === 'ArrowDown' && !decDisabled) {
          const val = Math.max(calc.sub(Number(value || 0), step), min);
          setValueStr(val.toString());
          onChange(val);
        }
      }
    }), suffix && /*#__PURE__*/_jsx("div", {
      className: "suffix",
      children: suffix
    })]
  });
};
const InputNumber = props => {
  const {
    size = 'm',
    type = 'outline',
    direction = 'vertical',
    max = Infinity,
    min = 0,
    precision,
    step = 1,
    autoAdjust,
    error,
    disabled,
    disabledInput,
    tooltips,
    suffix,
    onBlur,
    inputWidth,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const [value, onChange] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  const inputRef = useRef(null);
  const focusWithin = useFocusWithin(inputRef);
  const incDisabled = useMemo(() => {
    if (disabled) {
      return true;
    } else if (max !== undefined && value !== undefined && value >= max) {
      return true;
    } else {
      return false;
    }
  }, [value, max, step, disabled]);
  const decDisabled = useMemo(() => {
    if (disabled) {
      return true;
    } else if (min !== undefined && value !== undefined && value <= min) {
      return true;
    } else {
      return false;
    }
  }, [value, min, disabled]);
  const tooltipTitle = useCreation(() => {
    if (!isNumber(value) || !tooltips) {
      return null;
    }
    if (value >= max) {
      return isNone(tooltips === null || tooltips === void 0 ? void 0 : tooltips.max) ? null : tooltips.max;
    }
    if (value <= min) {
      return isNone(tooltips === null || tooltips === void 0 ? void 0 : tooltips.min) ? null : tooltips.min;
    }
    return null;
  }, [value, min, max, tooltips === null || tooltips === void 0 ? void 0 : tooltips.max, tooltips === null || tooltips === void 0 ? void 0 : tooltips.min]);

  //减
  const decEle = useMemo(() => /*#__PURE__*/_jsx("div", {
    ref: ref => {
      insertRipple({
        ref
      });
    },
    className: classNames('dec', {
      'dec-disabled': decDisabled
    }),
    onMouseDown: e => {
      e.preventDefault();
    },
    onClick: () => {
      var _inputRef$current;
      const numberValue = Number(value || 0);
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
      if (decDisabled) {
        return;
      }
      let v = numberValue;
      if (calc.mul(numberValue, 1000) % calc.mul(step, 1000) !== 0 && autoAdjust) {
        v = calc.mul(parseInt(calc.div(numberValue, step).toString()), step);
      } else {
        v = calc.sub(numberValue, step);
      }
      onChange(Math.max(v, min));
    },
    children: direction === 'vertical' ? /*#__PURE__*/_jsx(Icon, {
      type: "direction/DownLine"
    }) : /*#__PURE__*/_jsx(Icon, {
      type: "suggest/Minus"
    })
  }), [decDisabled, value, step, autoAdjust, min, direction]);

  //加
  const incEle = useMemo(() => /*#__PURE__*/_jsx("div", {
    ref: ref => {
      insertRipple({
        ref
      });
    },
    className: classNames('inc', {
      'inc-disabled': incDisabled
    }),
    onMouseDown: e => {
      e.preventDefault();
    },
    onClick: () => {
      var _inputRef$current2;
      const numberValue = Number(value || 0);
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.focus();
      if (incDisabled) {
        return;
      }
      let v = numberValue;
      if (calc.mul(numberValue, 1000) % calc.mul(step, 1000) !== 0 && autoAdjust) {
        const int = parseInt(calc.div(numberValue, step).toString());
        v = calc.add(calc.mul(int, step), step);
      } else {
        v = calc.add(numberValue, step);
      }
      onChange(Math.min(v, max));
    },
    children: direction === 'vertical' ? /*#__PURE__*/_jsx(Icon, {
      type: "direction/UpLine"
    }) : /*#__PURE__*/_jsx(Icon, {
      type: "suggest/Add"
    })
  }), [incDisabled, value, step, autoAdjust, max, direction]);
  if (direction === 'vertical') {
    return /*#__PURE__*/_jsxs(Wrap, {
      ...props,
      type: type,
      focusWithin: focusWithin,
      tooltip: {
        placement: tooltips === null || tooltips === void 0 ? void 0 : tooltips.placement,
        title: tooltipTitle
      },
      children: [/*#__PURE__*/_jsx(ContentDom, {
        type: type,
        error: !!error,
        disabled: disabled || disabledInput,
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        suffix: suffix,
        max: max,
        min: min,
        step: step,
        precision: precision,
        inputWidth: inputWidth,
        incDisabled: incDisabled,
        decDisabled: decDisabled,
        _ref: inputRef
      }), /*#__PURE__*/_jsxs("div", {
        className: "direction",
        children: [incEle, decEle]
      })]
    });
  } else if (direction === 'horizontal') {
    return /*#__PURE__*/_jsxs(Wrap, {
      ...props,
      type: type,
      focusWithin: focusWithin,
      tooltip: {
        placement: tooltips === null || tooltips === void 0 ? void 0 : tooltips.placement,
        title: tooltipTitle
      },
      children: [decEle, /*#__PURE__*/_jsx(ContentDom, {
        type: type,
        error: !!error,
        disabled: disabled || disabledInput,
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        suffix: suffix,
        max: max,
        min: min,
        step: step,
        precision: precision,
        inputWidth: inputWidth,
        incDisabled: incDisabled,
        decDisabled: decDisabled,
        _ref: inputRef
      }), incEle]
    });
  }
  return null;
};
export default InputNumber;